import { useMutation } from '@gogame/query';

import { sendSmartRuleActionCallback } from 'scenes/SmartRules/sources/smartRules';

import { callback } from '../queryKeyFactory';

export const useActionCallback = () => {
  const callbackMutation = useMutation(
    callback(),
    sendSmartRuleActionCallback,
    {
      errorMessage: false,
      successMessage: false,
    }
  );

  return [callbackMutation.mutateAsync, callbackMutation];
};
